// Generado desde design-system/components/motion/motion-styles.ts — no editar; edita el .ts/.tsx y corre build-ds.
import { injectStyles, SPRING_LINEAR } from './motion-utils';
/*
 * Hoja base de la familia motion: resorte real (--dbm-spring), presión,
 * revelado, escalonado y utilidades de demostración (cámara lenta).
 * Solo transform / opacity. Todo se apaga con prefers-reduced-motion.
 */
const CSS = `
:root { --dbm-spring: var(--db-ease-spring); }
@supports (transition-timing-function: linear(0, 1)) { :root { --dbm-spring: ${SPRING_LINEAR}; } }

/* ── Presión (principio 6) ───────────────────────────────────────── */
.dbm-press {
  transition: transform var(--db-dur-open) var(--dbm-spring), color var(--db-dur-base) var(--db-ease-out),
    background-color var(--db-dur-base) var(--db-ease-out), box-shadow var(--db-dur-base) var(--db-ease-out), opacity var(--db-dur-base) var(--db-ease-out);
  -webkit-tap-highlight-color: transparent;
}
.dbm-press:active:not([aria-disabled="true"]):not(:disabled), .dbm-press[data-pressed="true"] {
  transform: scale(var(--dbm-press, .96));
  transition-duration: var(--db-dur-fast);
  transition-timing-function: var(--db-ease-out);
}
.dbm-slowmo .dbm-press { transition-duration: 4.25s; }
.dbm-slowmo .dbm-press:active, .dbm-slowmo .dbm-press[data-pressed="true"] { transition-duration: .7s; }

/* ── Revelado al entrar en pantalla ─────────────────────────────── */
.dbm-reveal {
  opacity: 0;
  transform: translate3d(0, var(--dbm-y, 16px), 0) scale(var(--dbm-s, 1));
  transition: opacity var(--db-dur-close) var(--db-ease-out), transform var(--db-dur-open) var(--db-ease-expo);
  transition-delay: calc(var(--dbm-i, 0) * var(--dbm-stagger, 60ms) + var(--dbm-delay, 0ms));
}
.dbm-reveal[data-shown="true"], [data-shown="true"] > .dbm-reveal { opacity: 1; transform: none; }

/* ── Escalonado al montar (listas) ──────────────────────────────── */
.dbm-stagger { animation: dbm-rise var(--db-dur-open) var(--db-ease-expo) both; animation-delay: calc(var(--dbm-i, 0) * var(--dbm-stagger, 45ms)); }
@keyframes dbm-rise { from { opacity: 0; transform: translate3d(0, 14px, 0) scale(.98); } to { opacity: 1; transform: none; } }
.dbm-leave { animation: dbm-leave var(--db-dur-close) var(--db-ease-out) both; }
@keyframes dbm-leave { to { opacity: 0; transform: translate3d(24px, 0, 0) scale(.96); } }

/* ── Aparición con resorte (confirmaciones) ─────────────────────── */
.dbm-pop { animation: dbm-pop var(--db-dur-open) var(--dbm-spring) both; }
@keyframes dbm-pop { from { opacity: 0; transform: scale(.6); } to { opacity: 1; transform: none; } }

/* ── Giro continuo (anillo de login) ────────────────────────────── */
@keyframes dbm-spin { to { transform: rotate(1turn); } }

@media (prefers-reduced-motion: reduce) {
  .dbm-press, .dbm-press:active, .dbm-press[data-pressed="true"] { transition-duration: .01s !important; }
  .dbm-reveal { transform: none; transition: opacity .2s linear; transition-delay: 0s; }
  .dbm-stagger, .dbm-pop { animation: dbm-fade .2s linear both; animation-delay: 0s; }
  .dbm-leave { animation: dbm-fade-out .15s linear both; }
}
@keyframes dbm-fade { from { opacity: 0; } to { opacity: 1; } }
@keyframes dbm-fade-out { to { opacity: 0; } }
`;
export function ensureMotionStyles() {
    injectStyles('db-motion-styles', CSS);
}
ensureMotionStyles();
